import $ from "jquery";
import { Carousel } from "../vendor/embla-carousel";
import Autoplay from "embla-carousel-autoplay";

const sliderHomepage = () => {
    const el = {
        parent: ".mi-gallery--carousel",
        wrapper: ".mi-gallery--carousel__wrapper",
        item: ".mi-gallery--carousel__item",
    };

    let $parent;

    const defineVar = () => {
        $parent = $(el.parent);
    };

    const init = () => {
        document.addEventListener("DOMContentLoaded", function () {
            defineVar();

            if ($parent.length) {
                exec();
            }
        });
    };

    const exec = () => {
        const countSlideItem = $(el.item).length;
        console.log({ countSlideItem });

        new Carousel(
            {
                parentNode: $parent.parent().get(0),
                viewportNode: $parent.get(0),
                withBtn: false,
                lazyloaded: true,
            },
            { loop: true, speed: 800 },
            [
                Autoplay({
                    playOnInit: true,
                    delay: 30000,
                    stopOnInteraction: false,
                    stopOnMouseEnter: false,
                    stopOnFocusIn: false,
                    stopOnLastSnap: false,
                }),
            ],
        );

        $parent.trigger("click");

        // $parent.slick({
        //     arrows: false,
        //     slideToShow: 1,
        //     slideToScroll: 1,
        //     autoplay: true,
        //     speed: 800,
        //     pauseOnHover: false,
        //     pauseOnFocus: false,
        //     autoplaySpeed: overalSpeed,
        //     lazyLoad: "ondemand",
        // });

        // eslint-disable-next-line no-unused-vars
        // $parent.on("touchstart", (e) => {
        //     $parent.slick("slickPlay");
        // });
    };
    init();
};

try {
    sliderHomepage();
} catch (error) {
    console.error(error);
}
